import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IBusinessGroupNamesResponse } from '../models/shared.model';

export const businessGroupNamesFeatureKey = 'businessGroupNames';

export interface BusinessGroupNamesState {
  loadBusinessGroupNamesSuccess: IBusinessGroupNamesResponse[];
  loadBusinessGroupNamesFailure: Error | any;
}

export const initialState: BusinessGroupNamesState = {
  loadBusinessGroupNamesSuccess: undefined,
  loadBusinessGroupNamesFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadBusinessGroupNamesSuccess, (state, action) => ({
    ...state,
    loadBusinessGroupNamesSuccess: action.response
  }))
);

export const getBusinessGroupNames = (state: BusinessGroupNamesState) => state.loadBusinessGroupNamesSuccess;
